import React, { useState } from 'react'

import { useSelector, useDispatch } from 'react-redux'
import DateTimeCarousel from './DateTimeCourosel';

import '../../stylesheet/bookingPage.css';
import MovieTimingCard from './movieTimingCard';

export default function BookingPage() {

        const data = useSelector((state) => state.movie.value)
        const [TobeDisplayed, setTobeDisplayed] = useState(3)

        console.log(TobeDisplayed)
        return (
          
          <div> 
   
              <div className='main' style={{width:'60%', display:"block", }} >

                {data ? (
                  <div class="wrapper">
                        <div class="one"><img style={{width:'300px', height:'500px' }}src={data['poster']} /></div>
                        <div class="two"><h3>{data['title']} <br/><br/></h3> <p class= 'release'> <span>  Release date -  </span>{data['released'].split(' ').splice(0,3).join(' ')} <br/><br/>  </p> <p class = 'run' ><span>  Runtime - </span> {data['runtime']} Mins  </p> </div>
                        
                      
                        <div class="four"><h4>  <span style={{color: '#EA4C89'}}>  &#9734; </span> {data['imdb']['rating']}/10 {(data['imdb']['votes']/ 1000).toFixed(1)} Votes </h4>
                      

                        </div>
                      
                  </div>
                ) : (
                    <p>Loading data...</p>
                )}
              </div>

              <DateTimeCarousel setTobeDisplayed = {setTobeDisplayed}/>
              <MovieTimingCard theaterId = {data['theaterId']}/>
          
            
        </div>
        )
    }

